module.exports = __webpack_public_path__ + "static/img/Toby-Greene.2b64239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Toby-Greene.jpg
// module id = LTOx
// module chunks = 0